import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getTestOrder = (formData) => {
    return axiosInstance.post(`api/test-order/list`, formData);
}

export const getTestResult = (id) => {
    return axiosInstance.post(`api/test-order/view/${id}`,{});
}

export const createTestOrder = (id,formData) => {
    return axiosInstance.post(`api/test-order/test-result/${id}`,formData);
}

export const generateTestReport = (formData) => {
    return axiosInstance.post(`api/report/save-report-pdf`,formData);
}

export const reportList = (formData) => {
    return axiosInstance.post(`api/report/test-report-list`,formData);
}

export const sendEmail = (formData) => {
    return axiosInstance.post(`api/report/send-test-report-email`,formData);
}

export const sendWhatsApp = (formData) => {
    return axiosInstance.post(`api/report/send-test-report-whatsapp`,formData);
}

export const cancelTestOrder = (id) => {
    return axiosInstance.post(`api/test-payment/cancel-test-order/${id}`,{});
}

// export const masterSample = () => {
//     return axiosInstance.post(`api/master/samle-type/master`,{});
// }

// export const masterTest = () => {
//     return axiosInstance.post(`api/master/test-method/list `,{});
// }

// export const masterParameter = () => {
//     return axiosInstance.post(`api/parameters/master-list`,{});
// }

